export default __webpack_public_path__ + "static/media/outline-remove-red-eye-24-px.7e26bc42.svg";